<div class="chat-history">

  <!-- ── Search ── -->
  <div class="chat-history__search">
    <ui-form-field
      [formControl]="searchControl"
      [placeholder]="'ai_chat.search_placeholder' | translate"
    ></ui-form-field>
  </div>

  <!-- ── Conversation list ── -->
  <ng-container *ngIf="{ activeId: activeConversationId$ | async, loading: conversationListLoading$ | async } as ctx">
    <ul class="chat-history__list" role="listbox">

      <!-- Loading -->
      <li *ngIf="ctx.loading" class="chat-history__loading">
        <div class="chat-history__spinner"></div>
      </li>

      <ng-container *ngIf="!ctx.loading">
        <ng-container *ngIf="filteredConversations$ | async as conversations">
          <li
            *ngFor="let conv of conversations; trackBy: trackById"
            class="chat-history__item"
            [class.chat-history__item--active]="ctx.activeId === conv.id"
            role="option"
            [attr.aria-selected]="ctx.activeId === conv.id"
            (click)="selectConversation(conv.id)"
          >
            <div class="chat-history__item-body">
              <span class="chat-history__item-title" [title]="conv.title">{{ conv.title }}</span>
              <span class="chat-history__item-date">{{ conv.updatedAt | relativeDate }}</span>
            </div>
            <div class="chat-history__item-actions">
              <button
                class="chat-history__action-btn chat-history__action-btn--danger"
                [title]="'ai_chat.delete' | translate"
                (click)="deleteConversation($event, conv.id)"
              >
                <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                  <path d="M2 4h12M5 4V2h6v2M6 7v5M10 7v5M3 4l1 10h8l1-10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </li>

          <!-- Empty state -->
          <li *ngIf="conversations.length === 0" class="chat-history__empty">
            {{ 'ai_chat.empty_state' | translate }}
          </li>
        </ng-container>
      </ng-container>

    </ul>
  </ng-container>

</div>
